import translate from '../utils/utils';
export * from './AddressApi';
export * from './AvailableCredit';
export * from './ComputeApi';
export * from './ConfigApi';
export * from './constants';
export * from './ContractApi';
export * from './CreditApi';
export * from './FeatureFlags';
export * from './FeedbackApi';
export * from './FilteredCreditApplication';
export * from './FilteredWorksheet';
export * from './FinancingConfigApi';
export * from './FlinksApi';
export * from './HolidaysApi';
export * from './MerchantApi';
export * from './Newsletter';
export * from './RadioButtonListOption';
export * from './RefinanceApi';
export * from './Stepper';
export * from './UploadFileApi';
export * from './Vouched';
export const EMPTY_ARRAY = [];
export function translateFieldError(t, err, errorParams) {
    if (!err)
        return '';
    switch (err.type) {
        case 'required':
            return t('common.errors.required', { ns: 'shared', ...errorParams });
        case 'test-Sin-type':
            return t('common.errors.number', { ns: 'shared', ...errorParams });
        default:
            if (err.message)
                return translate(err.message, errorParams);
            return '';
    }
}
